import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';

export const useRedeemBatchTicketHeader = () => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const { goBack, canGoBack } = useNavigation();
  const handleGoBack = () => {
    if (canGoBack()) {
      goBack();
    }
  };

  const sliderWidth = isDesktop ? 0.45 : 1;

  return { handleGoBack, sliderWidth };
};
